import { Container } from "react-bootstrap";
import TabView from "./components/TabView";
import heraeusLogo from './img/Heraeus_Noblelight_RGB_Web_SafeZone_TranspBG.png'
import weissLogo from './img/Produktlogo_Schriftzug_farbig.png'

function App() {
  return (
    <div className="App">
      <Container>
        <div className="header">
          <img className="weiss-logo" src={weissLogo} />
          <div className="vertical-div"></div>
          <img className="heraeus-logo" src={heraeusLogo} />
        </div>
        <TabView />
      </Container>

    </div>
  );
}

export default App;
